<script>
  import { onMount } from 'svelte';
  import { loadLoginCatalogs, login } from '../lib/auth.js';
  import { COMPANY_NAME } from '../lib/config.js';
  export let onLogin;
  let catalogs = { users: [], warehouses: [], boxes: [] };
  let userId = ''; let warehouseId = ''; let boxId = ''; let password = '';
  let visible = false; let loading = true; let submitting = false; let error = '';
  async function load() {
    loading = true; error = '';
    try {
      catalogs = await loadLoginCatalogs();
      userId = catalogs.users[0].id; warehouseId = catalogs.warehouses[0].id; boxId = catalogs.boxes[0].id;
    } catch (reason) { error = reason.message; } finally { loading = false; }
  }
  async function submit() {
    if (submitting) return;
    submitting = true; error = '';
    try {
      const session = await login({ user: catalogs.users.find(item => item.id === userId), warehouse: catalogs.warehouses.find(item => item.id === warehouseId), box: catalogs.boxes.find(item => item.id === boxId), password });
      password = ''; onLogin(session);
    } catch (reason) { error = reason.message; } finally { submitting = false; }
  }
  onMount(load);
</script>
<main class="login-page">
  <section class="login-intro"><span class="brand-mark">V</span><h1>Vendey Pro</h1><p>Tu tienda, en orden.</p><strong>{COMPANY_NAME}</strong><p>Ventas, clientes e inventario en un solo lugar.</p><small>Versión web · Svelte</small></section>
  <form class="login-card" on:submit|preventDefault={submit}>
    <span class="eyebrow">made1ncamana</span><h2>Iniciar sesión</h2><p>Selecciona tu caja y almacén para comenzar.</p>
    <label>Usuario<select bind:value={userId} disabled={loading || submitting} required>{#each catalogs.users as item}<option value={item.id}>{item.name}</option>{/each}</select></label>
    <label for="login-password">Contraseña</label><div class="input-action"><input id="login-password" type={visible ? 'text' : 'password'} bind:value={password} autocomplete="current-password" required disabled={submitting} /><button type="button" class="secondary-action" aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'} aria-pressed={visible} on:click={() => visible = !visible}>{visible ? 'Ocultar' : 'Ver'}</button></div>
    <label>Almacén<select bind:value={warehouseId} disabled={loading || submitting} required>{#each catalogs.warehouses as item}<option value={item.id}>{item.name}</option>{/each}</select></label>
    <label>Caja<select bind:value={boxId} disabled={loading || submitting} required>{#each catalogs.boxes as item}<option value={item.id}>{item.name}</option>{/each}</select></label>
    {#if error}<p class="notice error" role="alert">{error}</p>{/if}
    <button class="primary-action" disabled={loading || submitting || !catalogs.users.length}>{loading ? 'Cargando catálogos…' : submitting ? 'Ingresando…' : 'Ingresar al sistema'}</button>
    <button type="button" class="text-button" on:click={load} disabled={loading || submitting}>Actualizar usuarios, almacenes y cajas</button>
  </form>
</main>
